export const SHOWCATID = 'cats/setCatsId'

export const SET_PROFILEBYID = 'profile/setProfileById'

export const SET_FRIENDS = 'friends/setFriends'
export const DELETE_PROFILEBYID_CAT = 'profile/setProfileByIdCat'

export const SET_CHAT_MESSAGE = 'chat/setChatMessage'
export const SHOWGETCAT = 'cats/setCats'
export const SET_RANDOMCARD = 'randomCard/setRandomCard'
